@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  color: var(--dark-60);
  display: flex;
  padding: 3px 5px;
  align-items: center;
  gap: 10px;
  height: 25px;
  width: 100%;
  border-radius: 6px;

  &.hovered,
  &.focusVisible {
    background: var(--light-40);
  }

  @include for-phone-only {
    height: 32px;
  }
}

.icon {
  display: flex;
  padding: 0 2px;
  align-items: center;
  svg {
    display: block;
  }
}

.text {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  @include xs-sohne-book;
  @include line-clamp;
  color: var(--dark-80);

  [data-autopilot-system-redesign='on'] & {
    color: var(--dark-60);
  }

  @include for-phone-only {
    font-size: 14px;
  }
}
